import * as ng from 'angular';
import * as WebFont from 'webfontloader';

const pcFonts = [
   'Arial',
   'Arial Black',
   'Century Gothic',
   'Georgia',
   'Helvetica',
   'Times New Roman',
];

const appFonts = [
   'Georgia',
   'Helvetica',
   'Times New Roman',
];

// google fonts
const webFonts = [
   'Lato',
   'Montserrat',
   'Open Sans',
   'Poppins',
   'Raleway',
   'Roboto',
   'Roboto Slab',
];

// self-hosted fonts
const customFonts = [
   'TWK Everett',
   'Proxima Nova'
];

export class FontService {
   readonly fonts:string[];
   readonly pcFonts:string[];
   readonly appFonts:string[];

   constructor() {
      WebFont.load({
         google: {
            families: webFonts
         }, custom: {
            families: customFonts
         }
      });

      this.fonts = pcFonts.concat(webFonts).concat(customFonts).sort();
      this.pcFonts = pcFonts.sort();
      this.appFonts = appFonts.concat(webFonts).concat(customFonts).sort();
   }
}

ng.module('e360').service('fonts', FontService);
